import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import ManagePostedJobsCard from '../../../../components/Card/ManagePostedJobsCard';
import { useAppSelector } from '../../../../redux/store';
import PaginationControl from '../../../../components/PaginationControl/PaginationControl';
import { useSearchParams } from 'react-router-dom';
import { APPLICATION } from '../../../../routes/routeConstants';
import useGetCreatedJobPosts from '../../../../hooks/jobs/useGetCreatedJobPosts';
import { LoadingOutlined } from '@ant-design/icons';
// import JobsCreatedSearchForm from './JobCreatedSearchForm';
import { usePostedJobsPage } from '../../../../context/PostedJobsPageContext';

export default function AllApps() {
  const { authData } = useAppSelector((state) => state.auth);

  // const [showMobileInfo, setShowMobileInfo] = useState<boolean>(false);

  const { currentPage, setCurrentPage, clearPage } = usePostedJobsPage();

  const [searchParams, setSearchParams] = useSearchParams();

  const perPage = 10;

  const userId = authData?.id;

  const { getCreatedJobPosts, loading } = useGetCreatedJobPosts();

  // ✅ Sync from query param on mount
  useEffect(() => {
    const pageFromUrl = Number(searchParams.get('page'));
    if (pageFromUrl && !isNaN(pageFromUrl)) {
      setCurrentPage(pageFromUrl);
    }
    // eslint-disable-next-line
  }, []);

  // ✅ Trigger API call when page or userId changes
  useEffect(() => {
    if (userId) {
      getCreatedJobPosts(
        { page: currentPage.toString(), perPage: perPage.toString() },
        userId
      );
    }
    // keep URL updated
    setSearchParams({ page: currentPage.toString() });
    // eslint-disable-next-line
  }, [currentPage, userId]);

  // const navigate = useNavigate();
  const jobsCreatedList = useAppSelector((state) => state.jobsCreatedList);

  useEffect(() => {
    return () => {
      // Clear page on unmount (only if navigating out completely, not to job details)
      if (!window.location.pathname.includes(`/${APPLICATION}`)) {
        clearPage();
      }
    };
  }, [clearPage]);

  return (
    <Container>
      {/* <NavigationArea onClick={() => navigate(`/${DASHBOARD}`)}>
        <LeftTriangleIcon />
        Back to Dashboard
      </NavigationArea> */}
      {/* <JobsCreatedSearchForm showMobileInfo={showMobileInfo} /> */}
      <Box>
        {loading ? (
          <LoadingWrapper>
            <LoadingOutlined style={{ fontSize: '2rem' }} />
          </LoadingWrapper>
        ) : (
          jobsCreatedList.jobData.map((data, index) => (
            <ManagePostedJobsCard key={index} job={data} />
          ))
        )}
      </Box>
      <PaginationShell>
        <PaginationControl
          endPage={
            jobsCreatedList.totalPages > 0 ? jobsCreatedList.totalPages : 1
          }
          changePage={(newPage: number) => setCurrentPage(newPage)}
          defaultNumOfPagination={5}
          currentPage={currentPage}
        />
      </PaginationShell>
    </Container>
  );
}

const Container = styled.div`
  margin-top: 32px;
  margin-bottom: 54px;
  // padding: 32px;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media (max-width: 480px) {
    // padding: 5px;
  }
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// const NavigationArea = styled.div`
//   display: flex;
//   align-items: center;
//   font-size: 18px;
//   color: #2f80ed;
//   font-weight: 500;
//   cursor: pointer;
//   width: fit-content;

//   & > svg {
//     transition: transform 0.3s ease-in-out;
//     transform: translateX(0);
//   }

//   &:hover > svg {
//     transform: translateX(-8px);
//   }
// `;

const PaginationShell = styled.div`
  display: grid;
  place-content: center;
  grid-column: span 2;

  @media (max-width: 884px) {
  }
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px; /* adjust height as needed */
`;
